import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store.js';

// Authenticate ==========================================
import AuthIndex from './views/auth/Index.vue';
import AuthRegsiter from './views/auth/register/Register.vue';
import AuthRegsiterCreatePin from './views/auth/register/CreatePin.vue';

import AuthLogin from './views/auth/login/Login.vue';
import AuthLoginVerify from './views/auth/login/LoginVerify.vue';

import AuthOtpVerify from './views/auth/OTPVerify.vue';
import AuthPinVerify from './views/auth/PINVerify.vue';

import AuthForget from './views/auth/forget/Forget.vue';
// Account Page ==========================================
import AccountIndex from './views/account/Index.vue';
import AccountUpgrade from './views/account/Upgrade.vue';
import AccountDataDiri from './views/account/DataDiri.vue';
import AccountProfile from './views/account/Profile.vue';
import AccountBusiness from './views/account/Business.vue';
import AccountDeveloper from './views/account/Developer.vue';
import AccountEmail from './views/account/Email.vue';
import AccountPin from './views/account/pin/Menu.vue';
import AccountPinForm from './views/account/pin/Form.vue';
import AccountPertanyaan from './views/account/Pertanyaan.vue';
import AccountStruk from './views/account/AturStruk.vue';
import AccountDeleteInfo from './views/account/delete-account/Info.vue';
import AccountDeleteForm from './views/account/delete-account/Form.vue';
// Info Page =============================================
import InfoIndex from './views/info/Index.vue';
// Referral Page =============================================
import ReferralIndex from './views/referral/Index.vue';
import ReferralDownline from './views/referral/Downline.vue';
import ReferralDownlineDetail from './views/referral/DownlineDetail.vue';
import ReferralKomisi from './views/referral/Komisi.vue';
import ReferralUpgrade from './views/referral/AboutAffiliatePlus.vue';
import ReferralTargetAffiliateIndex from './views/referral/target-affiliate/Index.vue';
import ReferralTargetAffiliateTerms from './views/referral/target-affiliate/Terms.vue';
import ReferralLeaderBoardIndex from './views/referral/leader-board/Index.vue';
import ReferralLeaderBoardTerms from './views/referral/leader-board/Terms.vue';

// History Transaction =============================================
import TransactionIndex from './views/transaction/Index.vue';
import TransactionPrabayarShow from './views/transaction/product/prabayar/Show.vue';
import TransactionPascabayarShow from './views/transaction/product/pascabayar/Show.vue';
import TransactionSendMoneyShow from './views/transaction/product/sendmoney/Show.vue';
import TransactionTransferShow from './views/transaction/product/transfer/Show.vue';
import TransactionDepositShow from './views/transaction/deposit/Show.vue';
// Page =============================================
import PageAbout from './views/page/About.vue';
// import PageTOS from './views/page/TOS.vue';
import PageFAQ from './views/page/FAQ.vue';
import PagePrivacy from './views/page/Privacy.vue';
import PageOther from './views/page/Other.vue';
import PageChannel from './views/page/Channel.vue';
import PageGuideDeleteAccount from './views/page/GuideDeleteAccount.vue';
// Other Page =============================================
import Beranda from './views/Beranda.vue';
import Other from './views/Other.vue';
import Deposit from './views/Deposit.vue';
import Transfer from './views/Transfer.vue';
import Withdrawal from './views/Withdrawal.vue';
// import ProductPrabayar from "./views/ProductPrabayar.vue";
// import OrderPrabayar from "./views/OrderPrabayar.vue";
// import Prabayar from "./views/Prabayar.vue";

// import ProductPrabayarPrefix from "./views/ProductPrabayarPrefix.vue";

import ProductPascabayar from './views/ProductPascabayar.vue';
import OrderPascabayar from './views/OrderPascabayar.vue';

// new order path =============================================
import PrabayarWithPrefixProduct from './views/order/prabayar/withPrefix/Product.vue';
import PrabayarWithPrefixOrder from './views/order/prabayar/withPrefix/Order.vue';

import PrabayarWithoutPrefixProduct from './views/order/prabayar/withoutPrefix/Product.vue';
import PrabayarWithoutPrefixOrder from './views/order/prabayar/withoutPrefix/Order.vue';

import PascabayarProduct from './views/order/pascabayar/Product.vue';
import PascabayarOrder from './views/order/pascabayar/Order.vue';

import PrabayarSpecialProduct from './views/order/prabayar/special/Product.vue';
import PrabayarSpecialOrder from './views/order/prabayar/special/Order.vue';

import SendMoneyOrder from './views/order/sendmoney/Order.vue';
import SendMoneyTos from './views/order/sendmoney/TOS.vue';

import PastiCuanTelkomselProduct from './views/order/pasti-cuan/telkomsel/Product.vue';
// import PrabayarSpecialOrder from './views/order/prabayar/special/Order.vue';
// =============================================

// import Pascabayar from "./views/Pascabayar.vue";
import Mutasi from './views/Mutasi.vue';
// Error Page =============================================
import NotFound from './views/404.vue';
import AccessDenied from './views/403.vue';

import CareCenter from './views/CareCenter.vue';

import Kemitraan from './views/Kemitraan.vue';

import Forward from './views/page/Forward.vue';
import Feedback from './views/page/Feedback.vue';

import Donasi from './views/donasi/Index.vue';
import AddDonasi from './views/donasi/Add.vue';
import PenyaluranDonasi from './views/donasi/Penyaluran.vue';

import Points from './views/points/Index.vue';
import PointsHistory from './views/points/history/Index.vue';

import QrisMerchant from './views/qris/Index.vue';
import QrisMerchantRegister from './views/qris/Register.vue';
import QrisMerchantList from './views/qris/List.vue';
import QrisMerchantListDetail from './views/qris/ListDetail.vue';
import QrisMerchantPaymentData from './views/qris/payment/Data.vue';
import QrisMerchantPaymentDetail from './views/qris/payment/Detail.vue';
import QrisMerchantSettlementData from './views/qris/settlement/Data.vue';
import QrisMerchantSettlementDetail from './views/qris/settlement/Detail.vue';

import TosData from './views/tos/Data.vue';
import TosDetail from './views/tos/Detail.vue';

import Maps from './views/Maps.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/maps',
        name: 'maps',
        component: Maps,
        meta: { requiresAuth: true },
        props: true,
    },
    // Authenticate ==========================================
    {
        path: '/auth',
        component: AuthIndex,
        children: [
            {
                path: 'register',
                name: 'auth.register',
                component: AuthRegsiter,
                props: true,
            },
            {
                path: 'register/pin',
                name: 'auth.register.pin',
                component: AuthRegsiterCreatePin,
                props: true,
            },
            {
                path: 'login',
                name: 'auth.login',
                component: AuthLogin,
                props: true,
            },
            {
                path: 'login/verify',
                name: 'auth.login.verify',
                component: AuthLoginVerify,
                props: true,
            },
            {
                path: 'otp/verify',
                name: 'auth.otp.verify',
                component: AuthOtpVerify,
                props: true,
            },
            {
                path: 'forget',
                name: 'auth.forget',
                component: AuthForget,
                props: true,
            },
            {
                path: 'pin/verify',
                name: 'auth.pin.verify',
                component: AuthPinVerify,
                props: true,
            },
        ],
    },
    // Account Page ==========================================
    {
        path: '/account',
        name: 'account',
        component: AccountIndex,
        meta: { requiresAuth: true },
    },
    {
        path: '/account/upgrade',
        name: 'account.upgrade',
        component: AccountUpgrade,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (store.state.customer.role == 'Member') next();
            else next({ name: 'account' });
        },
    },
    {
        path: '/account/data-diri',
        name: 'account.data-diri',
        component: AccountDataDiri,
        meta: { requiresAuth: true },
    },
    {
        path: '/account/profile',
        name: 'account.profile',
        component: AccountProfile,
        meta: { requiresAuth: true },
    },
    {
        path: '/account/business',
        name: 'account.business',
        component: AccountBusiness,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/account/developer',
        name: 'account.developer',
        component: AccountDeveloper,
        meta: { requiresAuth: true },
    },
    {
        path: '/account/email',
        name: 'account.email',
        component: AccountEmail,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/account/pin',
        name: 'account.pin',
        component: AccountPin,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/account/pin/form',
        name: 'account.pin.form',
        component: AccountPinForm,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/account/question',
        name: 'account.question',
        component: AccountPertanyaan,
        meta: { requiresAuth: true },
    },
    {
        path: '/account/struk',
        name: 'account.struk',
        component: AccountStruk,
        meta: { requiresAuth: true },
    },
    {
        path: '/account/delete/info',
        name: 'account.delete.info',
        component: AccountDeleteInfo,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/account/delete/form',
        name: 'account.delete.form',
        component: AccountDeleteForm,
        meta: { requiresAuth: true },
        props: true,
    },
    // Info Page =============================================
    {
        path: '/info',
        name: 'info.index',
        component: InfoIndex,
        meta: { requiresAuth: true },
        props: true,
    },
    // Referral Page =============================================
    {
        path: '/referral',
        name: 'referral.index',
        component: ReferralIndex,
        meta: { requiresAuth: true },
    },
    {
        path: '/referral/downline',
        name: 'referral.downline',
        component: ReferralDownline,
        meta: { requiresAuth: true },
    },
    {
        path: '/referral/downline/:id/detail',
        name: 'referral.downline.detail',
        component: ReferralDownlineDetail,
        meta: { requiresAuth: true },
    },
    {
        path: '/referral/komisi',
        name: 'referral.komisi',
        component: ReferralKomisi,
        meta: { requiresAuth: true },
    },
    {
        path: '/referral/upgrade',
        name: 'referral.upgrade',
        component: ReferralUpgrade,
        meta: { requiresAuth: true },
    },
    {
        path: '/referral/target',
        name: 'referral.target.index',
        component: ReferralTargetAffiliateIndex,
        meta: { requiresAuth: true },
    },
    {
        path: '/referral/target/terms',
        name: 'referral.target.terms',
        component: ReferralTargetAffiliateTerms,
        meta: { requiresAuth: true },
    },
    {
        path: '/referral/leader-board',
        name: 'referral.leader-board.index',
        component: ReferralLeaderBoardIndex,
        meta: { requiresAuth: true },
    },
    {
        path: '/referral/leader-board/terms',
        name: 'referral.leader-board.terms',
        component: ReferralLeaderBoardTerms,
        meta: { requiresAuth: true },
    },
    // History Transaction =============================================
    {
        path: '/transaction',
        name: 'transaction.index',
        component: TransactionIndex,
        meta: { requiresAuth: true },
    },
    {
        path: '/transaction/prabayar/:id',
        name: 'transaction.prabayar.show',
        component: TransactionPrabayarShow,
        meta: { requiresAuth: true },
    },
    {
        path: '/transaction/pascabayar/:id',
        name: 'transaction.pascabayar.show',
        component: TransactionPascabayarShow,
        meta: { requiresAuth: true },
    },
    {
        path: '/transaction/sendmoney/:id',
        name: 'transaction.sendmoney.show',
        component: TransactionSendMoneyShow,
        meta: { requiresAuth: true },
    },
    {
        path: '/transaction/deposit/:id',
        name: 'transaction.deposit.show',
        component: TransactionDepositShow,
        meta: { requiresAuth: true },
    },
    {
        path: '/transaction/transfer/:id',
        name: 'transaction.transfer.show',
        component: TransactionTransferShow,
        meta: { requiresAuth: true },
    },
    // Page =============================================
    {
        path: '/about',
        name: 'about',
        component: PageAbout,
        meta: { requiresAuth: true },
    },
    // { path: '/tos', name: 'tos', component: PageTOS },
    {
        path: '/faq',
        name: 'faq',
        component: PageFAQ,
    },
    { path: '/privacy', name: 'privacy', component: PagePrivacy },
    {
        path: '/channel',
        name: 'channel',
        component: PageChannel,
    },
    {
        path: '/panduan/permintaan-penghapusan-data-akun',
        name: 'panduan.delete-account',
        component: PageGuideDeleteAccount,
    },
    {
        path: '/page/:slug',
        name: 'page.other',
        component: PageOther,
        meta: { requiresAuth: true },
        props: true,
    },
    // Other Page =============================================
    {
        path: '/',
        name: 'home',
        component: Beranda,
        meta: { requiresAuth: true },
    },
    {
        path: '/other',
        name: 'other',
        component: Other,
        meta: { requiresAuth: true },
    },

    // old schema =============================================

    // {
    //   path: "/product-prabayar-prefix/:id",
    //   name: "product-prabayar-prefix",
    //   component: ProductPrabayarPrefix,
    //   meta: { requiresAuth: true },
    //   props: true,
    // },
    // {
    //   path: "/product-prabayar/:id",
    //   name: "product-prabayar",
    //   component: ProductPrabayar,
    //   meta: { requiresAuth: true },
    //   props: true,
    // },
    // {
    //   path: "/order-prabayar/:id",
    //   name: "order-prabayar",
    //   component: OrderPrabayar,
    //   meta: { requiresAuth: true },
    //   props: true,
    // },

    {
        path: '/product-pascabayar/:id',
        name: 'product-pascabayar',
        component: ProductPascabayar,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/order-pascabayar/:id',
        name: 'order-pascabayar',
        component: OrderPascabayar,
        meta: { requiresAuth: true },
        props: true,
    },

    // {
    //   path: "/prabayar/:id",
    //   name: "prabayar",
    //   component: Prabayar,
    //   meta: { requiresAuth: true },
    //   props: true,
    // },
    // {
    //   path: "/pascabayar/:id",
    //   name: "pascabayar",
    //   component: Pascabayar,
    //   meta: { requiresAuth: true },
    //   props: true,
    // },

    // =============================================
    // new schema =============================================

    {
        path: '/prabayar/with-prefix/product/:id',
        name: 'prabayar-with-prefix-product',
        component: PrabayarWithPrefixProduct,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/prabayar/with-prefix/order/:id',
        name: 'prabayar-with-prefix-order',
        component: PrabayarWithPrefixOrder,
        meta: { requiresAuth: true },
        props: true,
    },

    {
        path: '/prabayar/without-prefix/product/:id',
        name: 'prabayar-without-prefix-product',
        component: PrabayarWithoutPrefixProduct,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/prabayar/without-prefix/order/:id',
        name: 'prabayar-without-prefix-order',
        component: PrabayarWithoutPrefixOrder,
        meta: { requiresAuth: true },
        props: true,
    },

    {
        path: '/pascabayar/product/:id',
        name: 'pascabayar-product',
        component: PascabayarProduct,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/pascabayar/order/:id',
        name: 'pascabayar-order',
        component: PascabayarOrder,
        meta: { requiresAuth: true },
        props: true,
    },

    {
        path: '/prabayar/special/product/:id',
        name: 'prabayar-special-product',
        component: PrabayarSpecialProduct,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/prabayar/special/order/:id',
        name: 'prabayar-special-order',
        component: PrabayarSpecialOrder,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/sendmoney/order',
        name: 'sendmoney.order',
        component: SendMoneyOrder,
        meta: { requiresAuth: true },
        props: true,
    },
    { path: '/sendmoney/tos', name: 'sendmoney.tos', component: SendMoneyTos },

    {
        path: '/pasti-cuan/telkomsel/product',
        name: 'pasti-cuan.telkomsel.product',
        component: PastiCuanTelkomselProduct,
        meta: { requiresAuth: true },
        props: true,
    },
    // =============================================

    { path: '/deposit', name: 'deposit', component: Deposit },
    { path: '/transfer', name: 'transfer', component: Transfer, props: true },
    {
        path: '/withdrawal',
        name: 'withdrawal',
        component: Withdrawal,
        props: true,
    },
    { path: '/mutasi', name: 'mutasi', component: Mutasi },

    {
        path: '/kemitraan',
        name: 'kemitraan',
        component: Kemitraan,
        meta: { requiresAuth: true },
    },

    {
        path: '/donasi',
        name: 'donasi',
        component: Donasi,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/donasi/add',
        name: 'donasi.add',
        component: AddDonasi,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/donasi/penyaluran',
        name: 'donasi.penyaluran',
        component: PenyaluranDonasi,
        meta: { requiresAuth: true },
    },

    {
        path: '/points',
        name: 'points',
        component: Points,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/points/history',
        name: 'points.history',
        component: PointsHistory,
        meta: { requiresAuth: true },
        props: true,
    },

    {
        path: '/qris',
        name: 'qris',
        component: QrisMerchant,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/qris/register',
        name: 'qris.register',
        component: QrisMerchantRegister,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/qris/list',
        name: 'qris.list',
        component: QrisMerchantList,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/qris/list/:id',
        name: 'qris.list.detail',
        component: QrisMerchantListDetail,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/qris/payment',
        name: 'qris.payment.data',
        component: QrisMerchantPaymentData,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/qris/payment/:id',
        name: 'qris.payment.detail',
        component: QrisMerchantPaymentDetail,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/qris/settlement',
        name: 'qris.settlement.data',
        component: QrisMerchantSettlementData,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/qris/settlement/:id',
        name: 'qris.settlement.detail',
        component: QrisMerchantSettlementDetail,
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/tos',
        name: 'tos.data',
        component: TosData,
        props: true,
    },
    {
        path: '/tos/:id',
        name: 'tos.detail',
        component: TosDetail,
        props: true,
    },
    // Error Page =============================================
    { path: '/care-center', name: 'care-center', component: CareCenter },
    { path: '/404', name: '404', component: NotFound },
    { path: '/403', name: '403', component: AccessDenied, props: true },
    { path: '/forward', name: 'forward', component: Forward, props: true },
    {
        path: '/feedback/:token',
        name: 'feedback',
        component: Feedback,
        props: true,
    },
    { path: '*', redirect: '/404' },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        let auth = store.getters.isAuth;
        if (!auth) next({ name: 'auth.login' });
        else next();
    } else {
        next();
    }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAPK)) {
        const userAgent = navigator.userAgent;
        if (
            userAgent.substring(userAgent.length - 17, userAgent.length - 1) ==
            store.state.VUE_ENV.VUE_APP_PACKAGENAME_APK
        ) {
            next();
        } else {
            store.commit('SET_TOAST', {
                show: true,
                message: 'Halaman ini tidak dapat diakses, silahkan hubungi CS',
                tipe: 'default',
                icon: 'warning',
            });
        }
    } else {
        next();
    }
});

export default router;
